/**
 * Select Time Step
 */

import React from 'react';
import { format } from 'date-fns';
import { TimeSlotGrid } from '@/components/booking';
import type { TimeSlot } from '../types';

interface SelectTimeStepProps {
  selectedDate: Date;
  slots: TimeSlot[];
  selectedSlot: string | undefined;
  onSelectSlot: (slotStart: string) => void;
  loading: boolean;
  formatSlotTime: (slot: TimeSlot, timezone: string) => string;
  providerTimezone: string;
}

export const SelectTimeStep: React.FC<SelectTimeStepProps> = ({
  selectedDate,
  slots,
  selectedSlot,
  onSelectSlot,
  loading,
  formatSlotTime,
  providerTimezone,
}) => {
  return (
    <div>
      <h2 className='mb-1 text-2xl font-bold text-slate-900'>Select a Time</h2>
      <p className='mb-6 text-sm text-slate-500'>
        Available times for {format(selectedDate, 'EEEE, MMMM d')}
      </p>

      <TimeSlotGrid
        slots={slots.map(slot => ({
          start: slot.start,
          displayTime: formatSlotTime(slot, providerTimezone),
        }))}
        selectedSlot={selectedSlot}
        onSelectSlot={onSelectSlot}
        loading={loading}
        emptyMessage='No available times for this date. Please select another date.'
      />
    </div>
  );
};

